import { render, staticRenderFns } from "./catToUpload.vue?vue&type=template&id=3a030222&scoped=true"
import script from "./catToUpload.vue?vue&type=script&lang=js"
export * from "./catToUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a030222",
  null
  
)

export default component.exports